export function formatCashbackPercent(value: number | null | undefined): string {
  if (value == null) return '-';
  return `${value}%`;
}
